import { useSelector } from "react-redux";
import { selectIsKeyLoading, selectIsLoading } from "../app/uiSlice";

export const useGlobalLoading = () => useSelector(selectIsLoading);

export const useLoading = (key) => useSelector(selectIsKeyLoading(key));
